// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface SellerInquiryEndpointsProps {
  get_seller_inquiry_list: (page: number, size: number) => string; // 문의 이력 조회
  get_seller_inquiry_detail: (inquiryId: string) => string; // 문의 상세 조회
}

// 구매자 문의하기 관련 엔드포인트 정의
export const SellerInquiryEndpoints: SellerInquiryEndpointsProps = {
  get_seller_inquiry_list: (page, size) =>
    `api/seller/inquiries?page=${page}&size=${size}`, // 문의 이력 조회
  get_seller_inquiry_detail: (inquiryId: string) =>
    `api/seller/inquiries/${inquiryId}`, // 문의 상세 조회
};

export default SellerInquiryEndpoints;
